import type { Maybe } from '@adornis/base/utilTypes.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';
import type { AppliedContract } from '../../../entities/AppliedContract.js';
import { ContractEditEingruppierungSection } from './ContractEditEingruppierungSection.js';
import { ContractEditGeneralSection } from './ContractEditGeneralSection.js';
import { ContractEditSocialSecuritySection } from './ContractEditSocialSecuritySection.js';
import type { ContractForm } from './sharedContractEditParts.js';

interface ContractEditProps {
  form: ContractForm;
  contract: Maybe<AppliedContract>;
  hasEditPermission: boolean;
  /**
   * Whether the fields are currently editable. Parts that edit the document directly instead of through
   * `form.field` (the kostenstellen) are not covered by the form's `enabledFields` and need this.
   */
  canEdit: boolean;
  onKuendigungSet: (date: Date) => void;
  onChanged: () => void;
}

/** The expert view of the contract edit. Shows and edits all fields of the contract. */
export const ContractEdit = stateful((props: ContractEditProps) => {
  if (!props.contract) return nothing;

  return html`
    <div class="flex flex-col gap-2">
      <div class="card card-body">
        ${ContractEditGeneralSection({
          form: props.form,
          contract: props.contract,
          onKuendigungSet: props.onKuendigungSet,
          onChanged: props.onChanged,
        })}
      </div>
      <div class="card card-body">
        ${ContractEditEingruppierungSection({
          form: props.form,
          contract: props.contract,
          suffix: '1',
          hasEditPermission: props.hasEditPermission,
          canEdit: props.canEdit,
          onChanged: props.onChanged,
        })}
      </div>

      ${
        !props.hasEditPermission && !props.form.document?.agEingruppierung2
          ? nothing
          : html`
              <div class="card card-body">
                ${ContractEditEingruppierungSection({
                  form: props.form,
                  contract: props.contract,
                  suffix: '2',
                  hasEditPermission: props.hasEditPermission,
                  canEdit: props.canEdit,
                  onChanged: props.onChanged,
                })}
              </div>
            `
      }

      <div class="card card-body">
        ${ContractEditSocialSecuritySection({ form: props.form, contract: props.contract })}
      </div>
    </div>
  `;
});
